import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { fontWeights, typography } from '../../../../styles/typography';

const slideWidths = {
  md: '126%',
  lg: '143%',
  xl: '139%',
};

const slideHeights = {
  sm: 220,
  md: 341,
  lg: 400,
  xl: 306,
};

export const locations = css({
  '.swiper-slide': {
    opacity: 0.3,
    transition: 'opacity 1s',
  },

  '.swiper-slide-active': {
    opacity: 1,
  },

  '.slide-locations-footer': {
    opacity: 0,
  },

  '.swiper-slide-active .slide-locations-footer': {
    opacity: 1,
  },

  '.swiper-container': {
    position: 'static',
  },

  [MediaQueries.mdAndUp]: {
    '.swiper-container': {
      width: slideWidths.md,
    },
  },

  [MediaQueries.lgAndUp]: {
    height: '100%',

    '.swiper-container': {
      height: '100%',
      width: slideWidths.lg,
    },
  },

  [MediaQueries.xl]: {
    '.swiper-container': {
      width: slideWidths.xl,
    },
  },

  '.swiper-button-next': {
    backgroundColor: colorsPalette.white,
    backgroundImage: 'none',
    borderRadius: '50%',
    boxShadow: shadows.shadow40,
    cursor: 'pointer',
    width: 48,
    height: 48,
    right: 20,
    marginTop: 0,
    top: slideHeights.sm / 2,
    transform: 'translateY(-50%)',

    [MediaQueries.mdAndUp]: {
      top: slideHeights.md / 2,
      right: -32,
    },

    [MediaQueries.lgAndUp]: {
      top: slideHeights.lg / 2,
      right: -37,
    },

    [MediaQueries.xl]: {
      top: slideHeights.xl / 2,
      right: -30,
    },

    '::before': {
      position: 'absolute',
      fontFamily: 'icomoon',
      content: '"\\e913"', // Arrow next
      display: 'block',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
});

export const slide = css({
  [MediaQueries.mdAndUp]: {
    width: '83%',
  },

  [MediaQueries.lgAndUp]: {
    width: '76%',
  },
});

export const slideText = css({
  position: 'absolute',
  bottom: 0,
  zIndex: 1,
  padding: 16,

  [MediaQueries.mdAndUp]: {
    padding: 24,
  },
});

export const slidePicture = css({
  display: 'block',
  lineHeight: 0,
});

const slideHeightBase = css({
  height: slideHeights.sm,

  [MediaQueries.mdAndUp]: {
    height: slideHeights.md,
  },

  [MediaQueries.lgAndUp]: {
    height: slideHeights.lg,
  },

  [MediaQueries.xl]: {
    height: slideHeights.xl,
  },
});

export const slideImage = css(slideHeightBase, {
  objectFit: 'cover',
  width: '100%',
});

export const nonLocation = css(slideHeightBase, {
  backgroundColor: colorsPalette.grey10,
  color: colorsPalette.black,
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '0 40px',
  textAlign: 'center',
  textDecoration: 'none',
});

export const nonLocationIcon = css({
  fontSize: 33,
  color: colorsPalette.red,
  marginBottom: 16,
});

export const nonLocationDescription = css(typography.effra22, {
  maxWidth: 324,
});

export const nonLocationCta = css(typography.effra16, {
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  color: colorsPalette.black,
  marginTop: 24,
  textDecoration: 'none',
});

export const locationInfo = css({
  position: 'relative',
  display: 'block',

  '::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    background: `
      linear-gradient(180deg, rgba(57, 57, 57, 0) 0%,
      rgba(57, 57, 57, 0) 14.06%,
      rgba(57, 57, 57, 0) 50.13%,
      rgba(57, 57, 57, 0.8) 100%),
      linear-gradient(0deg, rgba(57, 57, 57, 0.2), rgba(57, 57, 57, 0.2))
    `,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
});

export const address = css(typography.effra18, {
  color: colorsPalette.white,
  fontWeight: fontWeights.medium,
});

export const price = css(typography.effra16, {
  color: colorsPalette.white,
  fontWeight: fontWeights.medium,
});

export const slideFooter = css({
  alignItems: 'flex-end',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'initial',
  height: 48,
  paddingTop: 16,

  [MediaQueries.mdAndUp]: {
    height: 56,
  },

  [MediaQueries.lgAndUp]: {
    height: 65,
  },

  [MediaQueries.xl]: {
    height: 62,
  },
});

export const bookTourContainer = css({
  display: 'flex',
  alignItems: 'center',
});

export const bookTourCta = css(typography.effra16, {
  backgroundColor: colorsPalette.transparent,
  border: 0,
  borderBottom: `1px solid ${colorsPalette.red10}`,
  color: colorsPalette.red,
  cursor: 'pointer',
  padding: 0,
  width: 'auto',
});

export const slideFooterBrand = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  lineHeight: 1,
});

export const partnerText = css({
  fontSize: 10,
  color: colorsPalette.grey40,
  marginTop: 4,
});

export const brandImageContainer = css({
  display: 'block',
});

export const brandImagePicture = css({
  display: 'block',
  textAlign: 'center',
  lineHeight: 0,
});

export const brandImage = css({
  maxHeight: 33,
  display: 'inline-block',
});
